/**
 * list of user's actions that should be tracked by application.
 */
export enum USER_ACTION {
    CREATE,
    READ,
    UPDATE,
    DELETE,
}
